export const objectToQueryParamsString = (objectParams: Record<string, unknown>) => {
  return Object.entries(objectParams)
    .filter(([, val]) => val != null && val !== undefined)
    .map(([key, val]) => `${key}=${val}`)
    .join('&')
}
